export var Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Preproduction"] = "preproduction";
    Environment["Production"] = "production";
})(Environment || (Environment = {}));
export var getEnv = function (environment) {
    var env = environment || process.env.ENVIRONMENT || Environment.Development;
    switch (env) {
        case Environment.Development:
        case Environment.Staging:
        case Environment.Preproduction:
        case Environment.Production:
            return env;
        default:
            throw new Error("Invalid environment ".concat(env));
    }
};
export var getAPIBaseURL = function (env) {
    switch (env) {
        case Environment.Development:
        default:
            return 'https://api.lendi-dev.net';
        case Environment.Production:
            return 'https://api.lendi.com.au';
        case Environment.Preproduction:
            return 'https://api.lendi-preprod.net';
        case Environment.Staging:
            return 'https://api.lendi-stg.net';
    }
};
//# sourceMappingURL=Environment.js.map